import React from 'react';
import { Button, Table, Header, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import ThreeColumnTableRow from './ThreeColumnTableRow';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

export default class EditCourse extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newEnglishName: '',
            name: '',
            newCourse: '',
            newIsGlobal: false,
            newNoGlobal: false,

            edit: false,
        };

        this.onChange = this.onChange.bind(this);
        this.edit = this.edit.bind(this);
    }


    edit(id, optLock, name, code, englishName) {
        let newCourse = {};
        let language = { twoLetterCode: 'en' };
        let translations = [{ name: englishName, language }];

        if (name) newCourse = { ...newCourse, name };
        if (englishName) newCourse = { ...newCourse, translations };
        if (code) newCourse = { ...newCourse, code };
        if (id) newCourse = { ...newCourse, id };
        if (optLock) newCourse = { ...newCourse, optLock };

        axios.put('/course/basic/', { ...newCourse })
            .then(res => {
                toast('Predmet je uspješno izmijenje!');
            })
            .catch(err => {
                toast('Došlo je do greške! Predmet nije izmijenjen.');
            });
        window.history.go(-1);
    }

    onChange(keyName, value) {
        this.setState({ [keyName]: value });
    }


    render() {
        const { courseBasic } = this.props.location.state;
        return (
            <div>
                <Header as="h1">Kreiranje predmeta</Header>
                <Segment.Group raised>
                    <Segment clearing>
                        <Header as="h3">
                            Izmjena predmeta: {courseBasic.name}
                        </Header>
                    </Segment>
                    <Segment clearing >
                        <Table celled unstackable compact>
                            <Table.Header>
                                <Table.Row>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                <ThreeColumnTableRow
                                    name="Naziv predmeta"
                                    keyName="name"
                                    value={courseBasic.name}
                                    onChange={this.onChange}
                                    edit={this.state.edit}
                                    defValue={courseBasic.name}
                                />
                                <ThreeColumnTableRow
                                    name="Naziv predmeta na engleskom jeziku"
                                    keyName="englishName"
                                    value={courseBasic.englishName}
                                    onChange={this.onChange}
                                    edit={this.state.edit}
                                    defValue={courseBasic.englishName}
                                />
                                <ThreeColumnTableRow
                                    name="Šifra predmeta"
                                    keyName="code"
                                    value={courseBasic.code}
                                    onChange={this.onChange}
                                    edit={this.state.edit}
                                    defValue={courseBasic.code}
                                />
                            </Table.Body>
                        </Table>
                        {!this.state.edit ?
                            <Button floated="right" primary onClick={() => this.setState({ edit: true })}>Izmijeni</Button>
                            : <div><Button floated="right" basic="true" color="blue" onClick={() => this.setState({ edit: false })}>Odustani</Button>
                                <Button
                                    floated="right"
                                    primary
                                    onClick={
                                        () => {
                                            this.edit(courseBasic.id, courseBasic.optLock, this.state.name, this.state.newCode, this.state.englishName);
                                        }
                                    }
                                >Sačuvaj izmjene</Button>
                            </div>}

                    </Segment>
                    <ToastContainer hideProgressBar />

                </Segment.Group >
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateCourse/EditCourse.js